import { actions } from '../actions';
const initialState = [];

export const servicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_SERVICES_SUCCEED:
      return action.payload;
    case actions.CREATE_SERVICE_SUCCEED:
      return [action.payload, ...state];
    case actions.UPDATE_SERVICE_SUCCEED:
      return state.map(service =>
        service.id === action.payload.id ? action.payload : service
      );
    case actions.DELETE_SERVICE_SUCCEED:
      return state.filter(service => service.id !== action.payload);
    default:
      return state;
  }
};
